import React from 'react';
import { Query } from "react-apollo";

import { channel } from '../../graphql/queries';
import { ColHead, ColError, ColLoading } from '../chunk';


class ChannelHead extends React.Component {

	render() {
		return (
			<Query query={channel} variables={{ id: this.props.channelId }}>
                {({ loading, error, data }) => {
                    if( loading ) return (<ColLoading />);
                    if( error ) return (<ColError error={error} />);
                    return <ColHead icon="comments" title={data.channel.name}  />;
                }}
            </Query>
      	)
	}
};

export default ChannelHead






// WEBPACK FOOTER //
// ./src/components/channel/ChannelHead.js